export default {
    address: {
        city: "Miasto",
        city_locality: "Miasto \/ Miejscowość",
        country: "Kraj",
        line1: "Adres Wiersz 1",
        line2: "Adres wiersz 2",
        postal_code: "Kod pocztowy",
        state: "Województwo",
        state_region: "Stan \/ Region"
    },
    alerts: {
        account_2fa: "Zabezpiecz swoje konto za pomocą uwierzytelniania dwuskładnikowego.",
        account_2fa_success: "Włączono uwierzytelnianie dwuskładnikowe.",
        activate_instruction: "Włączenie automatycznego zbierania recenzji spowoduje próbę zażądania recenzji od {count}. Przed włączeniem tej opcji przejrzyj swoje szablony.",
        activate_intro: "Ciągle proś o recenzje na podstawie swojej strategii.",
        agency_mcp_server: "Połącz Claude'a lub dowolnego klienta MCP z serwer MCP swojej agencji. Autoryzowani asystenci mogą zarządzać projektami, klientami i zespołem Twojej agencji w Twoim imieniu.",
        agency_sso: "Połącz się z dostawcą tożsamości OpenID Connect w celu logowania klienta.",
        ai_assistant: "Nazwa i opis Twojej firmy są wymagane, aby korzystać z AI do sugestii recenzji i odpowiedzi.",
        api_key_roll: "Czy na pewno chcesz zmienić swój klucz API ? Będzie to miało wpływ na każdą aplikację, która go używa.",
        ask_confirm: "Czy na pewno chcesz poprosić o recenzje od {count}? Spowoduje to zaplanowanie próśb dla wszystkich klientów, którzy jeszcze nie zostali poproszeni.",
        cname_delete: "Czy na pewno chcesz usunąć CNAME: {cname_name}?",
        cname_not_configured: "Ten rekord nie został jeszcze skonfigurowany. Proszę czekać...",
        cname_warning: "Wiadomości, które już zostały wysłane do Twoich klientów, będą zawierały uszkodzone linki.",
        connection_disabled: "Połączenie jest wyłączone. Proszę połączyć się ponownie.",
        customer_archive: "Czy na pewno chcesz zarchiwizować klienta: {customer_name}? Wszystkie niewysłane wiadomości zostaną anulowane.",
        customer_cancel: "Czy na pewno chcesz anulować wszystkie niewysłane wiadomości dla klienta: {customer_name}?",
        customer_ingest: "Podaj ten adres e-mail w polu UDW podczas wysyłania wiadomości do klientów, aby ich imię i nazwisko oraz adres e-mail zostały automatycznie zaimportowane.",
        customer_resubscribe: "Czy na pewno chcesz ponownie zasubskrybować klienta: {customer_name}?",
        customer_unarchive: "Czy na pewno chcesz przywrócić dane klienta: {customer_name}?",
        customer_unsubscribe: "Czy na pewno chcesz wypisać klienta: {customer_name}?",
        customer_unsubscribe_all: "Czy na pewno chcesz anulować subskrypcję {count} z otrzymywania wiadomości z tego projektu?",
        delete: "Czy na pewno chcesz usunąć {model}: {name}?",
        delete_count: "Czy na pewno chcesz usunąć {count}",
        domain_agency: "Dodaj własną domenę wysyłającą, aby w pełni oznakować swoją agencję jako białą etykietę.",
        domain_delete: "Czy na pewno chcesz usunąć domenę: {name}? Będziemy nadal wysyłać wiadomości e-mail z naszej własnej nazwy domeny.",
        domain_dmarc: "Dodaj rekord DMARC do swojej domeny, aby zmniejszyć ryzyko, że wiadomości e-mail trafią do spamu.",
        domain_project: "Dodaj domenę nadawczą, abyśmy mogli wysyłać wiadomości e-mail do Twoich klientów z Twojej własnej nazwy domeny.",
        export_confirm: "Czy na pewno chcesz wyeksportować wszystkie swoje {model}?",
        export_count: "Czy na pewno chcesz wyeksportować {count}?",
        export_link: "Link do pobrania zostanie wysłany na adres {email} wkrótce po wysłaniu żądania.",
        highlights_save_disabled: "Opcjonalnie możesz usunąć wyróżnienia ze wszystkich recenzji, które je obecnie zawierają.",
        highlights_save_enabled: "Aby wygenerować wyróżnienia dla wszystkich pozytywnych recenzji, zaznacz poniższe pole. Jeśli zmieniasz tylko kolor wyróżnienia, pozostaw to pole niezaznaczone.",
        integration_disconnect: "Czy na pewno chcesz rozłączyć się z {integration_name}?",
        integration_sync: "Czy na pewno chcesz zsynchronizować swoje konto {integration_name}? Będziemy stale importować Twoje dane.",
        intro: "Chcesz otrzymywać więcej pozytywnych recenzji od swoich klientów? Zaimportuj klientów, aby zacząć. Następnie poproś o recenzje ręcznie lub naciśnij przycisk „Automatyzacja” i pozwól, aby recenzje napłynęły.",
        logout: "Czy na pewno chcesz się wylogować?",
        mcp_server: "Połącz Claude'a lub dowolnego klienta MCP z tym projektem. serwer MCP umożliwia asystentom AI czytanie i zarządzanie recenzjami, klientami i wiadomościami w Twoim imieniu.",
        member_confirm: "Czy na pewno chcesz usunąć siebie? Utracisz dostęp do tego projektu.",
        member_confirm_all: "Czy na pewno chcesz usunąć siebie? Utracisz dostęp do wszystkich swoich projektów.",
        member_other_confirm: "Czy na pewno chcesz usunąć {noun}: {name}? Utracą dostęp do tego projektu.",
        member_other_confirm_all: "Czy na pewno chcesz usunąć {noun} {name}? Utracą dostęp do wszystkich swoich projektów.",
        message_cancel: "Czy na pewno chcesz anulować tę wiadomość?",
        message_cancel_all: "Czy na pewno chcesz anulować {count}? Ta akcja może być wykonana tylko na niewysłanych wiadomościach.",
        message_delete: "Czy na pewno chcesz usunąć tę wiadomość?",
        oauth_client_revoke: "Czy na pewno chcesz cofnąć dostęp dla {client}? Wszystkie aktywne sesje zostaną natychmiast rozłączone.",
        project_summary: "W tej chwili nie można wygenerować podsumowania.",
        project_suspend: "Czy na pewno chcesz zawiesić projekt: {project_name}?",
        project_unsuspend: "Czy na pewno chcesz cofnąć zawieszenie projektu: {project_name}?",
        review_delete: "Czy na pewno chcesz usunąć tę recenzję? Tej czynności nie można cofnąć.",
        review_page_confirm: "Czy na pewno chcesz zapisać zmiany?",
        review_page_default: "Czy na pewno chcesz ustawić stronę recenzji: {name} jako swoją stronę domyślną? Ta strona zostanie użyta, jeśli do żądania recenzji nie zostanie przypisana żadna inna strona.",
        review_page_delete: "Czy na pewno chcesz usunąć stronę recenzji: {name}? Wszyscy klienci, którzy są obecnie kierowani na tę stronę, zostaną przekierowani na Twoją domyślną stronę.",
        review_page_delete_all: "Czy na pewno chcesz usunąć {count}? Twoja domyślna strona recenzji nie zostanie usunięta.",
        review_page_fields: "Użyj pól, aby przechwycić informacje o kliencie podczas wystawiania recenzji. Dodaj więcej pól do formularza i warunkowo wyświetlaj je, gdy klienci wybiorą ocenę.",
        review_page_instructions: "Pokaż instrukcje bezpośrednio nad formularzem po wybraniu oceny.",
        review_page_location_picker: "Pozwól klientom wybrać dowolną lokalizację w projekcie dla recenzji. Zostanie ona wstępnie wybrana, jeśli Strona recenzji ma być wyświetlana dla określonej lokalizacji.",
        review_page_locations: "Wybierz lokalizacje, które powinny używać tej strony recenzji. Lokalizację można przypisać tylko do jednej strony recenzji. Jeśli lokalizacja nie ma przypisanej strony, użyje domyślnej strony recenzji.",
        review_page_redirects: "Pomiń formularz po wybraniu oceny i przekieruj gdzie indziej. Możesz również podzielić ruch na wiele stron internetowych, dodając więcej niż jedno przekierowanie dla każdej oceny.",
        share_template_delete: "Czy na pewno chcesz usunąć szablon udostępnienia „{name}”? Tej czynności nie można cofnąć.",
        smtp_remove: "Czy na pewno chcesz usunąć konfigurację SMTP ze swojego projektu? Twoja domena wysyłająca powróci do standardowej konfiguracji.",
        smtp_setup: "Wysyłaj e-maile z własnego serwera pocztowego. Wprowadź swoje dane uwierzytelniające SMTP. Jeśli Twój serwer używa ograniczeń IP, umieść na białej liście następujące adresy IP używane przez nasz system: {ips}.",
        space_delete: "Czy na pewno chcesz usunąć przestrzeń roboczą: {name}? Wszystkie projekty w niej zawarte zostaną usunięte.",
        tag_rule: "Dodaj pozytywny termin i jego negatywny odpowiednik. Jeśli ma zastosowanie, użyjemy AI, aby automatycznie oznaczyć recenzję jednym lub drugim.",
        user_delete: "Czy na pewno chcesz usunąć konto użytkownika: {email}?",
        user_verify: "Aby zweryfikować swój adres e-mail i aktywować konto, kliknij link w wiadomości e-mail wysłanej na adres: {email}.",
        widget_delete: "Czy na pewno chcesz usunąć widget: {name}? Widżet nie będzie już wyświetlany na żadnych stronach internetowych.",
        widget_restore: "Czy na pewno chcesz przywrócić ustawienia dla widżetu: {name}? Tylko projekt powróci do wartości domyślnych.",
        widgets_1: "Dodaj ten skrypt do treści swojej witryny.",
        widgets_2: "Ściana recenzji prezentuje wszystkie Twoje recenzje w formie siatki. Dodaj ten skrypt tam, gdzie ma być wyświetlany widżet.",
        widgets_3: "Wyróżniona recenzja prezentuje jedną dużą recenzję. Dodaj ten skrypt tam, gdzie ma być wyświetlany widżet."
    },
    billing_statuses: {
        active: "Twoja subskrypcja jest aktywna.",
        canceled: "Twoja subskrypcja została anulowana. Aby kontynuować, zaktualizuj ją.",
        ending: "Twoja subskrypcja kończy się {date}.",
        trial: "Twój bezpłatny okres próbny kończy się {date}.",
        trial_expired: "Twój bezpłatny okres próbny dobiegł końca. Aby kontynuować, zaktualizuj plan.",
        trial_expiring: "Twój bezpłatny okres próbny wkrótce się zakończy. Zaktualizuj, aby kontynuować."
    },
    brands: {
        boost_space: "Boost.space",
        discord: "Discord",
        email: "E-mail",
        facebook: "Facebook",
        google: "Google",
        google_analytics: "Google Analytics",
        hubspot: "HubSpot",
        linkedin: "LinkedIn",
        make_com: "Make.com",
        messenger: "Messenger",
        pabbly: "Pabbly",
        recaptcha: "reCAPTCHA",
        reddit: "Reddit",
        slack: "Slack",
        stripe: "Stripe",
        threads: "Threads",
        twilio: "Twilio",
        whatsapp: "WhatsApp",
        x: "X",
        zapier: "Zapier"
    },
    captions: {
        add_sending_domain: "Dodaj domenę wysyłającą, aby edytować swój adres e-mail:",
        agency_robots: "Zezwól wyszukiwarkom na indeksowanie Twojego portalu klienta.",
        ai_business_description: "Szczegółowy opis Twojej firmy, który pomoże Ci w generowaniu sugestii dotyczących recenzji i odpowiedzi.",
        ai_business_name: "Nazwa Twojej firmy.",
        ask_location: "Lokalizacja, do której ma zostać przypisana recenzja.",
        ask_review_page: "Strona służąca do przechwytywania recenzji.",
        assign_tags: "Przypisz etykiety do recenzji.",
        csv_max_rows: "Do {count} wierszy",
        dashboard_configure_settings: "Skonfiguruj ustawienia projektu.",
        dashboard_import_customers: "Importuj swoich klientów.",
        dashboard_preview_email_templates: "Podgląd szablonów wiadomości e-mail.",
        dashboard_preview_kiosk_page: "Podgląd strony kiosku.",
        dashboard_preview_review_page: "Wyświetl podgląd swojej strony recenzji.",
        dashboard_preview_showcase_page: "Obejrzyj podgląd swojej strony prezentacyjnej.",
        logo_height: "Wysokość logo w wiadomościach e-mail i na stronach.",
        meta_description: "Zastąp opis strony.",
        meta_title: "Zastąp tytuł strony.",
        mfa_password: "Wprowadź hasło swojego konta.",
        mfa_qr_code: "Zeskanuj kod QR za pomocą aplikacji uwierzytelniającej.",
        mfa_security_code: "Wprowadź kod z aplikacji uwierzytelniającej.",
        override_ambassador: "Wyświetlaj odznakę w wiadomościach e-mail, na stronach i widżetach swoich klientów.",
        project_name: "Nazwa Twojej firmy, marki lub strony internetowej.",
        project_robots: "Zezwól wyszukiwarkom na indeksowanie Twoich stron z recenzjami i prezentowanie ich.",
        setup_basics: "Ustaw, kiedy i jak prosisz klientów o opinie.",
        setup_business: "Podaj nam nazwę, pod którą znają Cię klienci.",
        setup_google: "Kieruj klientów do swojego profilu Google , odpowiadaj na recenzje i importuj istniejące. Możesz pominąć ten krok i zrobić to później.",
        setup_location_limit: "Twój okres próbny obejmuje 1 lokalizację. Zaktualizuj w dowolnym momencie, aby synchronizować więcej lokalizacji.",
        project_slug: "Używany w wiadomościach e-mail i linkach przeznaczonych dla klientów, jeśli rekord CNAME nie jest skonfigurowany.",
        review_page_copied_message: "Wyświetlane po przesłaniu pozytywnej recenzji.",
        review_page_email_address: "Recenzje wysyłaj na ten adres e-mail.",
        review_page_link_reveal_position: "Gdzie ujawnić linki.",
        review_page_link_revealer_label: "Etykieta ujawniająca linki.",
        review_page_link_revealer_rating: "Pokaż linki, jeśli klient wybierze tę ocenę lub wyższą, w przeciwnym razie pokaż przycisk umożliwiający ich pokazanie.",
        review_page_native_reviews: "Zezwalaj na recenzje na tej platformie.",
        review_page_rating_selection: "Zapisz ocenę przed wysłaniem recenzji.",
        review_page_success_button_link: "Jeśli to pole jest puste, link domyślnie kieruje do witryny Twojego projektu, w przeciwnym razie do domeny strony.",
        review_page_warning: "Jeśli uniemożliwisz klientom wystawianie publicznych opinii, Twoja oferta może zostać usunięta.",
        review_reply_status: "Nie możemy odpowiedzieć publicznie na tę recenzję. Zamiast tego możesz skontaktować się bezpośrednio z autorem recenzji.",
        review_suggestions: "Pomóż klientom pisać recenzje.",
        separate_with_commas: "Wielokrotności należy oddzielić przecinkami.",
        showcase_locations: "Ogranicz pokaz do określonych lokalizacji.",
        showcase_review_length: "Recenzje muszą mieć co najmniej tyle znaków.",
        showcase_since: "Pokaż recenzje utworzone w tym dniu lub przed tą datą.",
        showcase_sources: "Ogranicz prezentację do określonych źródeł.",
        showcase_tags: "Ogranicz prezentację do recenzji oznaczonych konkretnymi etykietami.",
        signature_html: "Skopiuj i wklej podpis do aplikacji pocztowej.",
        signed_up: "Data rozpoczęcia pracy przez klienta.",
        twilio_webhook: "Ustaw jako URL wywołania zwrotnego dla swojej usługi przesyłania wiadomości.",
        widget_embed: "Atrybut ID kontenera div, w którym będzie wyświetlany widget."
    },
    labels: {
        accept_all: "Akceptuj wszystko",
        access_code: "Kod dostępu",
        access_codes: "Kody dostępu",
        account: "Konto",
        account_sid: "Konto SID",
        action: "Działanie",
        actions: "Akcje",
        activate: "Aktywować",
        active: "Aktywny",
        active_subscription: "Aktywna subskrypcja",
        add: "Dodać",
        add_agency_project: "Dodaj projekt agencji",
        add_confirmation_message: "Dodaj wiadomość potwierdzającą.",
        add_css_rules: "Dodaj własne reguły css.",
        add_custom_field: "Dodaj pole niestandardowe",
        add_customer: "Dodaj klienta",
        add_customers_with: "Dodaj klientów z {model}",
        add_external_link: "Dodaj Link zewnętrzny",
        add_external_links: "Dodaj Linki zewnętrzne",
        add_introduction: "Dodaj wstęp.",
        add_js_tags: "Dodaj własne tagi JavaScript.",
        add_legal_information: "Dodaj informacje prawne.",
        add_location: "Dodaj lokalizację",
        add_project: "Dodaj projekt",
        add_review: "Dodaj recenzję",
        add_source: "Dodaj źródło",
        add_tag: "Dodaj Etykieta",
        added: "W dodatku",
        address: "Adres",
        advanced_review_pages: "Zaawansowane Strony Recenzji",
        affiliates: "Partnerzy",
        age_of_reviews: "Wiek Recenzje",
        agencies: "Agencje",
        agency: "Agencja",
        agency_name: "Nazwa agencji",
        agency_project: "Projekt agencji",
        agency_projects: "Projekty agencji",
        ai: "Sztuczna inteligencja",
        ai_answers: "Odpowiedzi AI",
        ai_assistant: "Asystent AI",
        ai_auto_tagging: "Automatyczne tagowanie AI",
        ai_reviews_and_replies: "Sugestie i odpowiedzi AI dotyczące recenzji",
        ai_tagging_instructions: "Przykład: Zastosuj do recenzji, które wspominają o czasie oczekiwania, powolnej obsłudze lub opóźnieniach.",
        all: "Wszystko",
        allowed_domains: "Dozwolone domeny",
        amount: "Kwota",
        analytics: "Analityka",
        and: "I",
        anonymous_reviews: "Anonimowe Recenzje",
        answer: "Odpowiedź",
        any: "Każdy",
        api: "API",
        api_key: "Klucz API",
        appearance: "Wygląd",
        approved: "Zatwierdzony",
        archive: "Archiwum",
        archive_customer: "Archiwum Klienta",
        archived: "Zarchiwizowano",
        at_least: "co najmniej",
        at_least_days: "Co najmniej {num} dni",
        at_least_hours: "Co najmniej {num} godzin",
        at_least_months: "Co najmniej {num} miesięcy",
        at_most: "najwyżej",
        at_most_days: "Maksymalnie {num} dni",
        at_most_hours: "Maksymalnie {num} godzin",
        at_most_months: "Maksymalnie {num} miesięcy",
        auth_token: "Token uwierzytelniający",
        authorize: "Autoryzować",
        auto_detect: "Automatyczne wykrywanie",
        auto_tags: "Auto-tagi",
        automate: "Zautomatyzować",
        automate_highlights: "Automatyczne wyróżnienia",
        automate_replies: "Automatyzuj odpowiedzi",
        automatic_review_collection: "Automatyczne zbieranie recenzji",
        automatically_apply_tags: "Automatycznie stosuj etykiety do istniejących recenzji",
        automating: "Automatyzacja",
        avatar: "Awatara",
        avatars: "Awatary",
        average_charge: "Średnia opłata",
        average_review: "Średnia recenzja",
        background_color: "Kolor tła",
        background_image: "Obraz tła",
        back: "Z powrotem",
        bcc: "BCC",
        bcc_email_address: "Adres e-mail BCC",
        best_to_worst: "Od najlepszego do najgorszego",
        billing: "Rozliczanie",
        blog: "Blog",
        body: "Treść",
        body_font_size: "Rozmiar czcionki Treść",
        bold: "Pogrubienie",
        book_a_demo: "Umów demo",
        bottom: "Spód",
        bottom_left: "Lewy dolny róg",
        bottom_right: "Prawy dolny róg",
        build_on: "Zbudowany na {model}",
        business: "Business",
        business_description: "Opis działalności gospodarczej",
        business_email: "Adres e-mail pomocy technicznej",
        business_name: "Nazwa firmy",
        business_phone: "Numer telefonu pomocy technicznej",
        business_website: "Strona internetowa firmy",
        button: "Przycisk",
        button_label: "Etykieta na Przycisk",
        button_link: "Link do Przycisk",
        button_position: "Pozycja Przycisk",
        button_size: "Rozmiar Przycisk",
        buy_me_a_coffee: "Kup mi kawę",
        by: "przez",
        by_signing_up: "Tworząc konto, wyrażasz zgodę na nasze",
        call_to_action: "Wezwanie do działania",
        cancel: "Anulować",
        cancel_1_message: "Anuluj 1 wiadomość",
        cancel_message: "Anuluj wiadomość",
        cancel_messages: "Anuluj wiadomości {count}",
        cancel_subscription: "Anuluj subskrypcję",
        cancel_unsent_messages: "Anuluj niewysłane wiadomości",
        canceled: "Odwołany",
        center: "Centrum",
        change: "Zmiana",
        change_key: "Zmień swój klucz API",
        change_plan: "Zmień plan",
        changelog: "Dziennik zmian",
        channel: "Kanał",
        channels: "Kanały",
        characters: "Znaki",
        charges_avg: "Średnia opłata musi wynosić co najmniej",
        charges_count: "Liczba opłat musi wynosić co najmniej",
        charges_sum: "Łączna kwota opłat musi wynosić co najmniej",
        chat_with_us: "Porozmawiaj z nami",
        checkbox: "Pole wyboru",
        claude: "Claude",
        clear: "Jasne",
        clear_highlights_from_reviews: "Usuń wyróżnienia ze wszystkich recenzji",
        clicked: "Kliknięto",
        client: "Klient",
        client_id: "Client ID",
        clients: "Klienci",
        close: "Zamknąć",
        cloudflare_warning: "Jeśli używasz Cloudflare, Twój serwer proxy musi być wyłączony.",
        cname: "CNAME",
        cname_setup_incomplete: "Instalacja nieukończona – zostanie usunięta w dniu {date}",
        cname_ssl_pending: "Oczekiwanie na certyfikat SSL",
        cname_status_for: "Status CNAME dla",
        code_editor: "Edytor kodu",
        collapse: "Zwiń",
        collect_reviews_anywhere: "Zbieraj recenzje w dowolnym miejscu",
        color: "Kolor",
        colors: "Zabarwienie",
        commission_rate: "Stawka prowizji",
        commission_status_approved: "Zatwierdzony",
        commission_status_paid: "Płatny",
        commission_status_pending: "Aż do",
        commission_status_reversed: "Wywrócony",
        community: "Wspólnota",
        company: "Firma",
        complained: "Skarżył się",
        confirm_new_password: "Potwierdź nowe hasło",
        confirmation_message: "Wiadomość potwierdzająca",
        connect: "Połącz",
        connect_bank: "Połącz konto bankowe",
        connect_google: "Połącz Google",
        connect_google_business_profile: "Connect Google Business Profile",
        connected: "Połączony",
        consent_preferences: "Preferencje zgody",
        contact_customer: "Skontaktuj się z klientem",
        contact_support: "Skontaktuj się z pomocą techniczną.",
        contact_us: "Skontaktuj się z nami",
        container_element: "Element kontenera",
        context: "Kontekst",
        continue: "Kontynuować",
        continue_with_google: "Kontynuuj z Google",
        cookie_category_analytics: "Analityka",
        cookie_category_essential: "Niezbędny",
        cookie_category_functional: "Funkcjonalny",
        cookie_category_marketing: "Marketing",
        cookie_consent_banner: "Baner zgody na pliki cookie",
        cookie_consent_scope_all: "Pokaż wszystkim",
        cookie_consent_scope_eea: "Pokaż tylko odwiedzającym z EOG i Wielkiej Brytanii",
        cookie_consent_scope_none: "Nie pokazuj",
        cookie_policy: "Polityka plików cookie",
        cookie_preference: "Preferencje dotyczące plików cookie",
        copied: "Skopiowano",
        copied_message: "Skopiowana wiadomość",
        copy: "Kopia",
        copy_embed_code: "Kopiuj kod do osadzenia",
        copy_signature: "Kopia Podpis",
        copy_source_code: "Kopiuj kod źródłowy",
        copy_uuid: "Kopiuj UUID",
        create: "Tworzyć",
        create_account: "Utwórz konto",
        create_agency: "Utwórz agencję",
        create_cname: "Utwórz rekord CNAME i wskaż go",
        create_external_link: "Utwórz Link zewnętrzny",
        create_field: "Utwórz pole",
        create_link: "Utwórz Link",
        create_location: "Utwórz lokalizację",
        create_project: "Utwórz projekt",
        create_qr_code: "Utwórz kod QR",
        create_review: "Utwórz recenzję",
        create_review_page: "Utwórz Strona Recenzji",
        create_signature: "Utwórz podpis",
        create_source: "Utwórz źródło",
        create_space: "Utwórz przestrzeń roboczą",
        create_tag: "Utwórz Etykieta",
        create_tag_rule: "Utwórz regułę Etykieta",
        create_webhook: "Utwórz webhook",
        create_widget: "Utwórz widget",
        crms: "CRMs",
        csv: "CSV",
        currency: "Waluta",
        current_plan: "Aktualny plan",
        current_year: "Bieżący rok",
        custom_field: "Pole niestandardowe",
        custom_instructions: "Instrukcje niestandardowe",
        custom_url: "Niestandardowy URL",
        customer: "Klient",
        customer_name_convention: "Konwencja nazwy klienta",
        customer_reviews: "Recenzje klientów",
        customers: "Klienci",
        customize: "Dostosuj",
        customize_review_page: "Dostosuj Strona Recenzji",
        daily: "Codziennie",
        daily_email_requests: "Codzienne prośby e-mailowe",
        daily_limit: "Dzienny limit",
        daily_requests: "Codzienne prośby",
        daily_sms_requests: "Codzienne prośby SMS",
        dark: "Ciemny",
        dashboard: "Panel sterowania",
        date: "Data",
        date_added: "Data dodania",
        date_canceled: "Data anulowania",
        date_clicked: "Data kliknięcia",
        date_complained: "Data złożenia skargi",
        date_delivered: "Data dostarczenia",
        date_failed: "Data nieudana",
        date_messaged: "Data wysłania wiadomości",
        date_opened: "Data otwarcia",
        date_replied: "Data odpowiedzi",
        date_requested: "Data żądania",
        date_reviewed: "Data Zrecenzowano",
        date_scheduled: "Zaplanowana data",
        date_sent: "Data wysłania",
        date_signed_up: "Data rejestracji",
        date_updated: "Data aktualizacji",
        dates: "Daty",
        day: "Dzień",
        days: "Dni",
        days_after_last_request: "dni po ostatnim żądaniu",
        days_later: "dni później",
        deactivate: "Dezaktywować",
        default: "Domyślny",
        default_language: "Język domyślny",
        default_review_page: "Domyślna Strona Recenzji",
        default_review_visibility: "Domyślna widoczność recenzji",
        default_tone: "Domyślny ton",
        delay: "Opóźnienie",
        delete: "Usuwać",
        delete_1_customer: "Usuń 1 klienta",
        delete_1_review: "Usuń 1 recenzję",
        delete_1_review_page: "Usuń 1 Strona recenzji",
        delete_1_widget: "Usuń 1 widżet",
        delete_agency: "Usuń agencję",
        delete_custom_field: "Usuń pole niestandardowe",
        delete_customer: "Usuń klienta",
        delete_customers: "Usuń klientów",
        delete_external_link: "Usuń Link zewnętrzny",
        delete_field: "Usuń pole",
        delete_link: "Usuń Link",
        delete_location: "Usuń lokalizację",
        delete_message: "Usuń wiadomość",
        delete_n_customers: "Usuń klientów {count}",
        delete_n_review_pages: "Usuń Strony recenzji {count}",
        delete_n_reviews: "Usuń Recenzje {count}",
        delete_n_widgets: "Usuń widżety {count}",
        delete_project: "Usuń projekt",
        delete_qr_code: "Usuń kod QR",
        delete_reply: "Usuń odpowiedź",
        delete_review: "Usuń recenzję",
        delete_review_page: "Usuń Strona Recenzji",
        delete_review_pages: "Usuń Strony Recenzji",
        delete_reviews: "Usuń Recenzje",
        delete_signature: "Usuń Podpis",
        delete_source: "Usuń źródło",
        delete_space: "Usuń Przestrzeń robocza",
        delete_tag: "Usuń Etykieta",
        delete_tag_rule: "Usuń regułę Etykieta",
        delete_template: "Usuń szablon",
        delete_user: "Usuń użytkownika",
        delete_webhook: "Usuń webhook",
        delete_widget: "Usuń widżet",
        delete_widgets: "Usuń widżety",
        deleted: "Usunięto",
        delivered: "Dostarczony",
        description: "Opis",
        deselect_all: "Odznacz wszystko",
        disable: "Wyłączyć",
        disable_automatic_review_collection: "Wyłącz automatyczne zbieranie recenzji",
        disable_field: "Wyłącz pole",
        disable_when_links_are_visible: "Wyłącz, gdy linki są widoczne",
        disabled: "Wyłączony",
        disconnect: "Odłączyć",
        disconnect_integration: "Rozłącz integrację",
        discord_community: "Społeczność Discord",
        display_name: "Nazwa wyświetlana",
        dmarc: "DMARC",
        dmarc_status_for: "Status DMARC dla",
        do_not_hide_from_public: "Nie ukrywaj się przed opinią publiczną",
        do_not_send: "Nie wysyłaj",
        documentation: "Dokumentacja",
        domain: "Domena",
        domain_name: "Nazwa domeny",
        dont_have_an_account: "Nie masz konta?",
        dont_send_thanks: "Nie wysyłaj podziękowań",
        download: "Pobierać",
        download_records: "Pobierz rekordy",
        download_template: "Pobierz szablon",
        dpa: "DPA",
        dsar: "DSAR",
        duplicate: "Duplikat",
        duplicate_project: "Duplikat projektu",
        duplicate_review_page: "Duplikat Strona Recenzji",
        duplicate_reviews: "Duplikaty Recenzje",
        duplicate_widget: "Duplikat widżetu",
        edit: "Redagować",
        edit_1_customer: "Edytuj 1 Klienta",
        edit_1_review: "Edytuj 1 recenzję",
        edit_client: "Edytuj Klient",
        edit_custom_field: "Edytuj pole niestandardowe",
        edit_customer: "Edytuj klienta",
        edit_customers: "Edytuj klientów",
        edit_field: "Edytuj pole",
        edit_link: "Edytuj Link",
        edit_location: "Edytuj lokalizację",
        edit_member: "Edytuj członka",
        edit_n_customers: "Edytuj klientów {count}",
        edit_n_reviews: "Edytuj {count} Recenzje",
        edit_notes: "Edytuj notatki",
        edit_qr_code: "Edytuj kod QR",
        edit_reviews: "Edytuj Recenzje",
        edit_signature: "Edytuj Podpis",
        edit_source: "Edytuj źródło",
        edit_strategy: "Edytuj strategię",
        edit_tag: "Edytuj Etykieta",
        edit_tag_rule: "Edytuj regułę Etykieta",
        edit_team_member: "Edytuj członka zespołu",
        edit_visibility: "Edytuj widoczność",
        edit_webhook: "Edytuj webhook",
        editable_ratings: "Edytowalne oceny",
        earned: "Zarobione",
        eligible: "Odpowiedni",
        email: "E-mail",
        email_address: "Adres e-mail",
        email_validation_invalid: "Weryfikacja adresu e-mail nie powiodła się",
        email_validation_passed: "Weryfikacja adresu e-mail przebiegła pomyślnie",
        email_validation_unknown: "Nie udało się zweryfikować adresu e-mail",
        emails: "E-maile",
        embed_code: "Osadź kod",
        enable: "Włączać",
        enable_automatic_review_collection: "Włącz automatyczne zbieranie recenzji",
        enable_for_all_reviews: "Włącz dla wszystkich recenzji",
        enable_for_positive_reviews: "Włącz dla pozytywnych recenzji",
        enable_on_review_pages: "Włącz na stronach recenzji",
        enabled: "Włączony",
        end: "Koniec",
        ends: "Kończy się",
        exclude: "Wykluczać",
        exclude_email: "Wyklucz e-mail",
        exclude_sms: "Wyklucz SMS",
        excluded_channels: "Wykluczone kanały",
        expand: "Zwiększać",
        expired: "Wygasły",
        export: "Eksport",
        export_1_customer: "Eksport 1 Klient",
        export_1_review: "Eksportuj 1 recenzję",
        export_all: "Eksportuj wszystko",
        export_all_customers: "Eksportuj wszystkich klientów",
        export_all_reviews: "Eksportuj wszystkie Recenzje",
        export_customers: "Klienci eksportowi",
        export_n_customers: "Eksportuj klientów {count}",
        export_n_reviews: "Eksportuj {count} Recenzje",
        export_reviews: "Recenzje eksportowe",
        external_link: "Link zewnętrzny",
        external_links: "Linki zewnętrzne",
        extra_locations: "Dodatkowe lokalizacje",
        faces: "Twarze",
        failed: "Nieudane",
        feedback: "Informacja zwrotna",
        field: "Pole",
        fields: "Pola",
        filter: "Filtr",
        first: "Pierwszy",
        first_charged: "Pierwszy naliczony",
        first_name: "Imię",
        first_name_last_initial: "Imię, pierwsza litera nazwiska",
        flag_as_duplicate: "Oznacz jako duplikat",
        font: "Czcionka",
        font_family: "Rodzina czcionek",
        font_size: "Rozmiar czcionki",
        footer: "Stopka",
        for: "Dla",
        forgot_password: "Zapomniałem hasła",
        form: "Formularz",
        free: "Bezpłatny",
        free_requests_included: "Bezpłatne prośby wliczone w cenę",
        from: "z",
        full_name: "Pełne imię i nazwisko",
        generate: "Generuj",
        generate_meta: "Generuj meta",
        generate_qr_code: "Wygeneruj kod QR",
        generate_reply: "Wygeneruj odpowiedź",
        generate_review: "Wygeneruj recenzję",
        generating: "Generowanie",
        get_started: "Rozpocznij",
        get_started_checklist: "Lista kontrolna rozpoczęcia",
        get_the_lifetime_deal: "Skorzystaj z oferty na całe życie",
        getting_started: "Rozpoczęcie pracy",
        google_fonts: "Czcionki Google",
        grouped_by_request: "Grupowane według żądania",
        has_links: "Ma Linki",
        has_notes: "Ma notatki",
        has_redirects: "Ma przekierowania",
        have_an_account: "Masz konto?",
        header: "Nagłówek",
        hidden: "Ukryty",
        hidden_from_search_engines: "Ukryte przed wyszukiwarkami",
        hidden_reviews: "Ukryte Recenzje",
        hide: "Ukrywać",
        hide_all_reviews: "Ukryj wszystkie recenzje",
        hide_avatar: "Ukryj awatar",
        hide_date: "Ukryj datę",
        hide_drop_shadow: "Ukryj cień",
        hide_field_label: "Ukryj etykietę pola",
        hide_from_public: "Ukryj przed publicznym",
        hide_name: "Ukryj nazwę",
        hide_pagination: "Ukryj paginację",
        highlight_color: "Podświetl kolor",
        host: "Host",
        hours: "Godziny",
        icon: "Ikona",
        icon_size: "Rozmiar ikony",
        icons: "Ikony",
        id: "ID",
        image: "Obraz",
        import: "Import",
        import_address1: "Adres klienta, wiersz 1.",
        import_address2: "Drugi wiersz adresu klienta.",
        import_city: "Miasto lub miejscowość klienta.",
        import_company: "Nazwa firmy klienta.",
        import_created_at: "Data recenzji.",
        import_customers: "Klienci importowi",
        import_email: "Adres e-mail klienta.",
        import_first_name: "Imię klienta.",
        import_from_boost_space: "Importuj z Boost.space",
        import_from_facebook: "Importuj z Facebooka",
        import_from_google: "Importuj z Google",
        import_from_hubspot: "Importuj z HubSpot",
        import_from_make_com: "Importuj z Make.com",
        import_from_pabbly: "Importuj z Pabbly",
        import_from_stripe: "Importuj ze Stripe",
        import_from_zapier: "Importuj z Zapier",
        import_last_name: "Nazwisko klienta.",
        import_list: "Lista rozdzielona przecinkami",
        import_notes: "Notatki przeznaczone wyłącznie do użytku wewnętrznego.",
        import_phone: "Numer telefonu klienta.",
        import_postal_code: "Kod pocztowy klienta.",
        import_recent_reviews: "Importuj ostatnie Recenzje",
        import_review: "Tekst recenzji.",
        import_reviews: "Recenzje importu",
        import_score: "Ocena od 1 do 5.",
        import_signed_up_at: "Data rozpoczęcia pracy przez klienta.",
        import_slug: "slug lub UUID",
        import_state: "Stan lub region klienta.",
        incentive: "Zachęta",
        include: "Włączać",
        include_sample_reviews: "Dołącz przykładowe recenzje",
        incoming_webhook_url: "Przychodzący URL webhooka",
        inherit: "Dziedziczyć",
        initializing: "Inicjalizacja",
        initials: "Inicjały",
        insert_variable: "Wstaw zmienną",
        instructions: "Instrukcje",
        integration: "Integracja",
        integrations: "Integracje",
        interval: "Interwał",
        introduction: "Wstęp",
        invite: "Zapraszać",
        invite_client: "Zaproś Klient",
        invite_failed: "Zaproszenie nie powiodło się",
        invite_member: "Zaproś członka",
        invite_sent_to: "Zaproszenie wysłane do",
        invite_team_member: "Zaproś członka zespołu",
        invited: "Zaproszony",
        issuer_url: "URL wystawcy",
        italic: "italski",
        joined: "Dołączył",
        key: "Klawisz",
        keywords: "Słowa kluczowe",
        keywords_in_replies: "Słowa kluczowe w odpowiedziach",
        keywords_in_reviews: "Słowa kluczowe w Recenzje",
        kiosk_page: "Strona kiosku",
        label: "Etykieta",
        label_font_size: "Rozmiar czcionki etykiety",
        labels: "Etykiety",
        language: "Język",
        languages: "Języki",
        large: "Duży",
        last_charged: "Ostatnio naliczone",
        last_name: "Nazwisko",
        layout: "Układ",
        leave: "Wyjechać",
        leave_project: "Opuść projekt",
        leave_space: "Zostaw Przestrzeń robocza",
        left: "Lewy",
        let_clients_sign_in_with_sso: "Pozwól klientom logować się przez SSO",
        less: "mniej",
        lifecycle_stage: "Etap cyklu życia",
        lifetime_deal: "Oferta na całe życie",
        light: "Światło",
        limit: "Limit",
        limits: "Ograniczenia",
        link: "Link",
        link_color: "Kolor linku",
        link_reveal_position: "Pozycja ujawnienia Link",
        link_revealer_button: "Przycisk ujawniania Link",
        link_revealer_label: "Etykieta ujawniająca Link",
        link_revealer_rating: "Ocena ujawniającego Link",
        links: "Linki",
        links_per_review_page: "Linki na Strona Recenzji",
        list: "Lista",
        list_unsubscribe_headers: "Nagłówki List-Unsubscribe",
        load_more: "Załaduj więcej",
        loading: "Załadunek",
        location: "Lokalizacja",
        location_address: "Adres lokalizacji",
        location_name: "Nazwa lokalizacji",
        location_picker: "Wybór lokalizacji",
        locations: "Lokalizacje",
        locations_limit: "Limit lokalizacji",
        log_in: "Zaloguj się",
        log_out: "Wyloguj się",
        logo: "Logo",
        logo_height: "Wysokość logo",
        long: "Długi",
        lowest_rating: "Najniższa ocena",
        ltd: "LTD",
        make_default: "Ustaw jako domyślne",
        manage: "Zarządzać",
        manage_limits: "Zarządzaj limitami",
        manage_overrides: "Zarządzaj nadpisaniami",
        manage_payout_account: "Zarządzaj kontem wypłat",
        manage_subscription: "Zarządzaj subskrypcją",
        manual_entry: "Wprowadzanie ręczne",
        max: "Maksymalnie",
        max_size: "Maksymalny rozmiar",
        maximum_characters: "Maksymalna liczba Znaki",
        maximum_customers: "Maksymalna liczba klientów",
        maximum_locations: "Maksymalna liczba lokalizacji",
        maximum_members: "Maksymalna liczba członków",
        maximum_review_length: "Maksymalna długość recenzji",
        maximum_tags: "Maksymalna liczba Etykiety",
        maximum_widgets: "Maksymalna liczba widżetów",
        mcp: "Serwer MCP",
        mcp_server: "Serwer MCP",
        mcp_server_url: "URL Serwer MCP",
        medium: "Średni",
        member: "Członek",
        members: "Członkowie",
        menu: "Menu",
        message: "Wiadomość",
        message_link_expiration: "Wygaśnięcie Link wiadomości",
        messaged: "Wiadomość",
        messages: "Wiadomości",
        messages_clicked: "Kliknięte wiadomości",
        messages_sent: "Wiadomości wysłane",
        messaging_service_sid: "Usługa przesyłania wiadomości SID",
        min: "Min",
        min_size: "Minimalny rozmiar",
        minimal_delay: "Minimalne opóźnienie",
        minimum_characters: "Minimalna liczba Znaki",
        minutes: "Minuty",
        month: "miesiąc",
        monthly: "Miesięczny",
        monthly_email_requests: "Miesięczne prośby e-mailowe",
        monthly_limit: "Miesięczny limit",
        monthly_pricing_only: "Tylko cennik miesięczny",
        monthly_request_limit: "Miesięczny limit żądań",
        monthly_requests: "Miesięczne prośby",
        monthly_sms_requests: "Miesięczne prośby SMS",
        months: "Miesiące",
        months_free: "{count} Miesiące za darmo",
        more: "więcej",
        more_clients: "więcej klientów",
        more_customers: "więcej klientów",
        more_options: "Więcej opcji",
        more_patients: "więcej pacjentów",
        more_reviews: "więcej recenzji",
        more_reviews_needed: "Potrzeba więcej recenzji, aby podsumować",
        more_users: "więcej użytkowników",
        more_visitors: "więcej odwiedzających",
        move: "Przenosić",
        moved: "Przeniesiono",
        name: "Nazwa",
        native_reviews: "Recenzje rodzime",
        negative_term: "Termin negatywny",
        negative_trends: "Negatywne trendy",
        new: "Nowy",
        new_password: "Nowe hasło",
        no: "Nie",
        no_available_options: "Brak dostępnych opcji",
        no_credit_card_required: "Nie jest wymagana karta kredytowa",
        no_data_available: "Brak dostępnych danych",
        no_negative_trends: "Na razie nie ma negatywnych trendów",
        no_positive_trends: "Brak jeszcze pozytywnych trendów",
        no_reminders: "Nie wysyłaj przypomnień",
        no_retries: "Brak ponownych prób",
        no_review: "Brak recenzji",
        none: "Nic",
        not_connected: "Nie połączono",
        not_reviewed: "Bez recenzji",
        notes: "Notatki",
        notifications: "Powiadomienia",
        now: "Teraz",
        number_of_charges: "Liczba opłat",
        number_of_reminders: "Liczba przypomnień",
        number_of_retries: "Liczba ponownych prób",
        number_of_review_suggestions: "Liczba sugestii recenzji",
        of: "z",
        off: "Wyłączony",
        on: "Na",
        on_channel: "na kanale {channel}.",
        opened: "Otwierany",
        options: "Opcje",
        or_log_in_with_email: "lub zaloguj się za pomocą swojego adresu e-mail",
        or_sign_up_with_email: "lub użyj swojego adresu e-mail",
        our_reviews: "Nasze Recenzje",
        output: "Wyjście",
        page_footer: "Stopka strony",
        paid: "Płatny",
        paragraph: "Ustęp",
        password: "Hasło",
        past_month: "Poprzedni miesiąc",
        past_months: "Ostatnie {inc} miesięcy",
        past_week: "Miniony tydzień",
        past_year: "Miniony rok",
        past_years: "Minione {inc} lat",
        paused: "Wstrzymano",
        payment_method: "Metoda płatności",
        payout_status_completed: "Zakończony",
        payout_status_pending: "Aż do",
        pending: "Aż do",
        pending_deployment: "Oczekujące wdrożenie",
        pending_validation: "Oczekujące na walidację",
        per_day: "za dzień",
        per_month: "na miesiąc",
        permissions: "Uprawnienia",
        phone: "Telefon",
        phone_number: "Numer telefonu",
        pixels: "piksele",
        placeholder: "Symbol zastępczy",
        placement: "Umieszczenie",
        plan: "Plan",
        plan_bullet1: "Usuń naszą markę z wiadomości e-mail, stron i widżetów",
        plan_bullet2: "Użyj swojej domeny do wyświetlania stron dla klientów i wysyłania wiadomości e-mail",
        plan_bullet3: "Uczyń produkt swoim dzięki białemu etykietowaniu dla agencji",
        please_rate_our_service: "Proszę ocenić naszą usługę",
        png: "PNG",
        policies: "Polityki",
        popular: "Popularny",
        port: "Port",
        position: "Pozycja",
        positive_only: "Tylko pozytywne Recenzje",
        positive_term: "Termin pozytywny",
        positive_trends: "Pozytywne trendy",
        powered_by: "Zasilane przez",
        preview: "Zapowiedź",
        preview_kiosk_page: "Podgląd strony kiosku",
        preview_review_page: "Podgląd Strona Recenzji",
        price: "Cena",
        pricing: "Wycena",
        primary_color: "Kolor podstawowy",
        priority: "Priorytet",
        privacy_policy: "Polityka prywatności",
        proceed_to_dashboard: "Przejdź do pulpitu nawigacyjnego",
        product: "Produkt",
        profile: "Profil",
        project: "Projekt",
        project_name: "Nazwa projektu",
        setup_ask_delay: "Jak długo czekać przed poproszeniem o recenzję",
        setup_reminders: "Ile przypomnień wysłać",
        project_paused: "Ten projekt został wstrzymany.",
        project_suspended: "Ten projekt został zawieszony.",
        project_website: "Strona internetowa projektu",
        projects: "Projekty",
        projects_limit: "Limit projektów",
        publish: "Publikować",
        publish_changes: "Opublikuj zmiany na wszystkich pozostałych stronach recenzji",
        published: "Opublikowany",
        purchase: "Zakup",
        qr_code: "Kod QR",
        qr_code_name_placeholder: "Stolik 1, recepcja",
        qr_codes: "Kody QR",
        quantity: "Ilość",
        query: "Zapytanie",
        quick_import: "Szybki import",
        rating: "Ocena",
        rating_order: "Kolejność oceniania",
        rating_out_of: "ocena z",
        rating_save_all: "Zapisz ocenę przed każdą recenzją",
        rating_save_customer: "Zapisz ocenę przed wystawieniem opinii przez klienta",
        rating_save_never: "Nigdy nie zapisuj oceny przed wystawieniem recenzji",
        rating_selection: "Wybór oceny",
        rating_selector: "Selektor ocen",
        ratings: "Oceny",
        read: "Czytać",
        reapply_highlights_eligible: "Regeneruj wyróżnienia za pomocą sztucznej inteligencji dla wszystkich pozytywnych recenzji",
        reconnect: "Na nowo połączyć",
        redeem: "Odkupić",
        redirect_uri: "URI przekierowania",
        redirects: "Przekierowania",
        refer_and_earn: "Polecaj i zarabiaj",
        referral_billing_status_active: "Subskrybowany",
        referral_billing_status_canceled: "Odwołany",
        referral_billing_status_trial: "Test",
        referral_billing_status_trial_expired: "Okres próbny wygasł",
        referral_billing_status_trial_expiring: "Okres próbny wygasa",
        referral_program: "Warunki programu poleceń",
        referrals: "Polecenia",
        refresh: "Odświeżać",
        regenerate: "Zregenerować",
        reject_all: "Odrzuć wszystko",
        related_reviews: "Podobne Recenzje",
        related_similarity: "Podobieństwo",
        remaining: "Pozostały",
        reminder: "Przypomnienie",
        reminders: "Przypomnienia",
        remove: "Usunąć",
        remove_client: "Usuń Klient",
        remove_cname: "Usuń CNAME",
        remove_domain: "Usuń domenę",
        remove_from_project: "Usuń z projektu",
        remove_member: "Usuń członka",
        remove_smtp_configuration: "Usuń konfigurację SMTP",
        remove_team_member: "Usuń członka zespołu",
        rename: "Przemianować",
        rename_template: "Zmień nazwę szablonu",
        renews: "Odnawianie",
        replied: "Odpowiedziano",
        reply: "Odpowiedź",
        reply_to: "Adres odpowiedzi",
        replying_on: "Odpowiadając na",
        request: "Żądanie",
        request_date: "Data żądania",
        request_review: "Poproś o recenzję",
        request_reviews: "Poproś o Recenzje",
        requested: "Poproszono",
        requested_review: "Żądana recenzja",
        requests: "Prośby",
        requests_left_this_month: "prośby pozostawione w tym miesiącu",
        requests_remaining: "Pozostałe prośby",
        require_field: "Wymagane pole",
        require_subscription: "Klient musi mieć aktywną subskrypcję",
        required: "Wymagany",
        reschedule_message: "Zmień harmonogram wiadomości",
        resend_invite: "Wyślij ponownie zaproszenie",
        reset_password: "Zresetuj hasło",
        restore: "Przywrócić",
        restore_to_defaults: "Przywróć ustawienia domyślne",
        restore_widget: "Przywróć widżet",
        resubscribe: "Subskrybuj ponownie",
        resubscribe_customer: "Klient ponownie subskrybujący",
        resync: "Ponowna synchronizacja",
        resync_account: "Ponowna synchronizacja konta",
        resync_now: "Synchronizuj ponownie teraz",
        retries: "Ponowne próby",
        reveal_above_form: "Ujawnij powyższy formularz",
        reveal_after_submission: "Ujawnij po przesłaniu",
        reveal_below_form: "Pokaż poniższy formularz",
        review: "Recenzja",
        review_length: "Długość recenzji",
        review_link: "Link do recenzji",
        review_missed: "Recenzja pominięta",
        review_not_requested: "Recenzja nie została zażądana",
        review_origin: "Ta recenzja pochodzi z szablonu",
        review_page: "Strona recenzji",
        review_pages: "Strony recenzji",
        review_requested: "Prośba o recenzję",
        review_spotlight: "Wyróżniona recenzja",
        review_suggestion: "Sugestia recenzji",
        review_suggestions: "Sugestie recenzji",
        review_text: "Tekst recenzji",
        review_wall: "Ściana recenzji",
        reviewed: "Zrecenzowano",
        reviews: "Recenzje",
        reviews_ask: "Zapytać",
        reviews_query_failed: "Coś poszło nie tak. Spróbuj ponownie.",
        reviews_query_placeholder: "Przeszukaj recenzje lub zadaj pytanie...",
        reviews_with_highlights: "Recenzje z najważniejszymi informacjami",
        reviews_with_replies: "Recenzje z odpowiedziami",
        reviews_without_replies: "Recenzje bez odpowiedzi",
        revoke: "Unieważnić",
        revoke_client: "Odwołaj aplikację",
        roadmap: "Mapa drogowa",
        role: "Rola",
        sans_serif: "Bezszeryfowy",
        save: "Zapisz",
        save_preferences: "Zapisz preferencje",
        save_template: "Zapisz szablon",
        save_template_as_new: "Zapisz nowy szablon",
        saved: "Zapisano",
        schedule: "Harmonogram",
        schedule_review_request: "Prośba o recenzję",
        scheduled: "Zaplanowany",
        score: "Wynik",
        search: "Szukaj",
        second: "Drugi",
        secret_key: "Klucz tajny",
        sections: "Sekcje",
        security_code: "Kod bezpieczeństwa",
        select: "Wybierać",
        select_account: "Wybierz konto",
        select_all: "Zaznacz wszystko",
        select_an_option: "Wybierz opcję",
        select_bulk_action: "Wybierz akcję zbiorczą",
        select_csv_file: "Wybierz plik CSV",
        select_date: "Wybierz datę",
        select_field: "Wybierz pole",
        select_icon: "Wybierz ikonę",
        select_location: "Wybierz lokalizację",
        select_plan: "Wybierz plan",
        select_review: "Wybierz recenzję",
        select_source: "Wybierz źródło",
        select_tag: "Wybierz Etykieta",
        selected: "Wybrany",
        send: "Wysłać",
        send_1_reminder: "Wyślij 1 przypomnienie",
        send_2_reminders: "Wyślij 2 przypomnienia",
        send_3_reminders: "Wyślij 3 przypomnienia",
        send_anytime: "Wyślij w dowolnym momencie",
        send_between: "Wyślij pomiędzy",
        send_message: "Wyślij wiadomość",
        send_retries: "Wyślij {count} ponownych prób",
        send_retry: "Wyślij {count} Ponów próbę",
        send_test: "Wyślij test",
        send_thanks: "Wyślij podziękowania",
        sender_email_address: "Adres e-mail nadawcy",
        sender_id: "ID nadawcy",
        sender_name: "Nazwa nadawcy",
        sending_domain: "Wysyłanie domeny",
        sent: "Wysłano",
        sent_replies: "Wysłane odpowiedzi",
        serif: "Szeryfowy",
        settings: "Ustawienia",
        share: "Udział",
        share_link: "Udostępnij Link",
        short: "Krótki",
        show: "Pokazywać",
        show_1_suggestion: "Pokaż jedną sugestię",
        show_100_results: "Pokaż 100 wyników",
        show_2_suggestions: "Pokaż dwie sugestie",
        show_25_results: "Pokaż 25 wyników",
        show_3_suggestions: "Pokaż trzy sugestie",
        show_4_suggestions: "Pokaż cztery sugestie",
        show_5_suggestions: "Pokaż pięć sugestii",
        show_50_results: "Pokaż 50 wyników",
        show_all_reviews: "Pokaż wszystkie recenzje",
        show_arrows: "Pokaż strzałki",
        show_avatar: "Pokaż awatar",
        show_cookie_consent_banner: "Pokaż baner zgody na pliki cookie",
        show_date: "Pokaż datę",
        show_dots: "Pokaż kropki",
        show_drop_shadow: "Pokaż cień",
        show_field: "Pokaż pole dla następujących ocen",
        show_full: "Pokaż pełne gwiazdki",
        show_photo: "Pokaż tylko zdjęcie",
        show_positive_reviews: "Pokaż tylko pozytywne recenzje",
        show_to_public: "Pokaż publicznie",
        showcase: "Showcase",
        showcase_page: "Strona pokazowa",
        sign_up: "Zapisać się",
        sign_up_for_free: "Zarejestruj się za darmo",
        sign_up_with_email: "Zarejestruj się e-mailem",
        sign_in_with_sso: "Zaloguj się za pomocą SSO",
        sign_up_with_google: "Zarejestruj się przez Google",
        signature: "Podpis",
        signatures: "Podpisy",
        signed_up: "Zarejestrowany",
        since: "Od",
        size: "Rozmiar",
        skip: "Pominąć",
        slug: "Slug",
        small: "Mały",
        sms: "SMS",
        smtp_configuration: "Konfiguracja SMTP",
        sort: "Sortować",
        source: "Źródło",
        source_code: "Kod źródłowy",
        sources: "Źródła",
        space: "Przestrzeń robocza",
        space_name: "Nazwa Przestrzeń robocza",
        spaces: "Przestrzenie robocze",
        split: "Podział",
        sso: "SSO",
        star_color: "Kolor gwiazdy",
        stars: "Gwiazdy",
        start: "Start",
        start_free_trial: "Rozpocznij bezpłatny okres próbny",
        start_getting_more_reviews: "Zacznij otrzymywać więcej Recenzje",
        status: "Status",
        store_code: "Kod sklepu",
        strategy: "Strategia",
        sub_processors: "Podprocesorzy",
        subject: "Temat",
        subscribe: "Subskrybować",
        subscription: "Prenumerata",
        success_page: "Strona sukcesu",
        suggestion: "Sugestia",
        suggestions: "Sugestie",
        summary: "Streszczenie",
        support: "Wsparcie",
        suspend: "Wstrzymać",
        suspend_project: "Zawieś projekt",
        suspended: "Zawieszony",
        svg: "SVG",
        switch_to_smtp_setup: "Przełącz na konfigurację SMTP",
        switch_to_standard_setup: "Przełącz na konfigurację standardową",
        symbol: "Symbol",
        sync: "Synchronizacja",
        sync_account: "Synchronizuj konto",
        sync_now: "Synchronizuj teraz",
        sync_scheduled_time: "Zaplanowana synchronizacja {time}",
        synced_time: "Zsynchronizowano {time}",
        system: "System",
        system_fonts: "Czcionki systemowe",
        tag: "Etykieta",
        tag_1_customer: "Klient Etykieta 1",
        tag_1_review: "Oznacz 1 recenzję",
        tag_customers: "Oznacz klientów",
        tag_existing_reviews: "Oznacz etykietami istniejące recenzje",
        tag_n_customers: "Etykieta klientów {count}",
        tag_n_reviews: "Oznacz {count} recenzji",
        tag_reviews: "Oznacz recenzje",
        tag_rule: "Reguła tagu",
        tag_with_ai: "Oznacz tagiem AI",
        tags: "Etykiety",
        tags_for_customers: "Etykiety dla klientów",
        tags_for_reviews: "Etykiety dla recenzji",
        team: "Zespół",
        team_member: "Członek zespołu",
        team_members: "Członkowie zespołu",
        template: "Szablon",
        templates: "Szablony",
        terms_of_service: "Warunki korzystania z usługi",
        test_template: "Szablon testowy",
        tests: "Testy",
        text: "Tekst",
        text_alignment: "Wyrównanie tekstu",
        text_color: "Kolor tekstu",
        thank_you_messages: "Wiadomości z podziękowaniami",
        thanks: "Dzięki",
        theme: "Temat",
        third: "Trzeci",
        time_zone: "Strefa czasowa",
        timeframe: "Okres czasu",
        title: "Tytuł",
        tone: "Ton",
        top: "Szczyt",
        top_left: "Lewy górny róg",
        top_right: "Prawy górny róg",
        total_charges: "Łączne opłaty",
        total_reviews: "Całkowita liczba Recenzje",
        trigger: "Spust",
        trigger_charged: "Wyślij żądanie po pobraniu opłaty",
        trigger_created: "Wyślij prośbę po rejestracji",
        try_free: "Wypróbuj za darmo",
        try_it_free: "Wypróbuj za darmo",
        type: "Typ",
        types: "Typy",
        unarchive: "Usuń z archiwum",
        unarchive_customer: "Przywróć klienta z archiwum",
        underline: "Podkreślać",
        unflag_as_duplicate: "Usuń flagę jako duplikat",
        unknown: "Nieznany",
        unlimited: "bez limitu",
        unnamed: "Anonimowy",
        unpublish: "Anuluj publikację",
        unpublished: "Niepublikowane",
        unreplied: "Nieodpowiedziano",
        unsent_messages: "Niewysłane wiadomości",
        unsubscribe: "Anuluj subskrypcję",
        unsubscribe_customer: "Anuluj subskrypcję klienta",
        unsubscribe_customers: "Klienci anulujący subskrypcję",
        unsubscribe_text: "Tekst anulowania subskrypcji",
        unsubscribed: "Wypisany",
        unsuspend: "Przywróć",
        unsuspend_project: "Przywróć projektu",
        unverified: "Niesprawdzony",
        update: "Aktualizacja",
        update_password: "Aktualizuj hasło",
        update_plan: "Aktualizuj plan",
        update_share_template: "Aktualizuj szablon",
        updated: "Zaktualizowano",
        updates: "Aktualizacje",
        upgrade: "Aktualizacja",
        upgrade_for_more: "Uaktualnij, aby uzyskać więcej",
        upgrade_to_use: "Aby korzystać z tej funkcji, należy dokonać aktualizacji",
        upload: "Wgrywać",
        upload_csv: "Prześlij plik CSV",
        upload_icon: "Prześlij ikonę",
        url: "URL",
        use: "Używać",
        use_filters_for_aggregate: "Użyj filtrów dla agregatów",
        user: "Użytkownik",
        user_id: "ID użytkownika",
        user_info: "Informacje o użytkowniku",
        username: "Nazwa użytkownika",
        utc: "UTC",
        validate: "Waliduj",
        validate_customer_email: "Sprawdź adres e-mail klienta",
        validation: "Walidacja",
        validations: "Walidacje",
        value: "Wartość",
        verify: "Zweryfikować",
        verify_email_address: "Zweryfikuj adres e-mail",
        view: "Zobacz",
        view_all: "Zobacz wszystko",
        view_all_features: "Zobacz wszystkie funkcje",
        view_available_fields: "Wyświetl dostępne pola",
        view_documentation: "Zobacz dokumentację",
        view_email_templates: "Wyświetl szablony wiadomości e-mail",
        view_review_pages: "Wyświetl Strony Recenzji",
        view_reviews: "Zobacz Recenzje",
        view_settings: "Ustawienia widoku",
        view_setup_guide: "Wyświetl przewodnik konfiguracji",
        view_showcase: "Zobacz galerię",
        view_strategy: "Wyświetl strategię",
        visibility: "Widoczność",
        visible: "Widoczny",
        visible_reviews: "Widoczne Recenzje",
        visible_to_search_engines: "Widoczne dla wyszukiwarek",
        wait_between_reminders: "Poczekaj między przypomnieniami",
        wait_period: "Okres oczekiwania",
        webhook: "Webhook",
        webhooks: "Webhooki",
        website: "Strona internetowa",
        weekly: "Tygodnik",
        weeks: "Tygodnie",
        widget: "Widżet",
        widgets: "Widżety",
        with_ai: "z AI",
        worst_to_best: "Od najgorszego do najlepszego",
        write: "Pisać",
        written_reviews: "Recenzje pisemne",
        year: "rok",
        yearly: "Rocznie",
        yes: "Tak",
        your_referral_link: "Twój Link polecający"
    },
    landing: {
        announcement: "Uzyskaj raporty reputacji dzięki naszemu serwerowi MCP",
        callout_1_subtitle: "Uzyskaj dostęp do wszystkich podstawowych funkcji przez 7 dni za darmo. Karta kredytowa nie jest wymagana. Zacznij otrzymywać więcej recenzje już teraz.",
        callout_1_title: "Bezpłatny okres próbny",
        callout_2_subtitle: "Importuj klientów za pomocą Stripe, HubSpot, Zapier, przesyłania CSV , poczty e-mail BCC, API i innych.",
        callout_2_title: "Szybka konfiguracja",
        callout_3_subtitle: "Ty decydujesz, do kogo i kiedy wysłać prośbę o recenzję. Codziennie wysyłamy prośby o recenzję do Twoich klientów.",
        callout_3_title: "Automatyczny",
        callout_4_subtitle: "Zbierz negatywne opinie zanim poprosisz klientów o wystawienie recenzje publicznej.",
        callout_4_title: "Trasowanie informacji zwrotnej",
        counter: "Dołącz do ponad 5 000 lokalnych firm usługowych",
        counter_agencies: "Używane przez ponad 500 agencji do zarządzania opiniami",
        industries: {
            accountants: "Księgowi",
            auto_repair: "Mechanicy samochodowi",
            chiropractors: "Kręgarze",
            cleaning: "Sprzątacze",
            contractors: "Wykonawcy",
            dentists: "Dentyści",
            doctors: "Lekarze",
            electricians: "Elektrycy",
            financial_advisors: "Doradcy finansowi",
            hvac: "Technicy HVAC",
            insurance_brokers: "Brokerzy ubezpieczeniowi",
            landscapers: "Ogrodnicy",
            law_firms: "Prawnicy",
            locksmiths: "Ślusarze",
            mortgage_brokers: "Pośrednicy kredytowi",
            optometrists: "Optometryści",
            pest_control: "Deratyzatorzy",
            personal_trainers: "Trenerzy personalni",
            physical_therapists: "Fizjoterapeuci",
            plumbers: "Hydraulicy",
            real_estate: "Pośrednicy nieruchomości",
            restaurants: "Właściciele restauracji",
            salons: "Fryzjerzy",
            self_storage: "Operatorzy magazynów",
            spas: "Kosmetyczki",
            tour_guides: "Przewodnicy turystyczni",
            veterinarians: "Weterynarze"
        },
        industries_title: "Zarządzanie opiniami dla lokalnych firm usługowych",
        agencies_screen_1_title: "Portal, o którym myślą, że go zbudowałeś",
        agencies_screen_2_title: "Kontroluj dostęp per klient",
        agencies_screen_3_title: "AI, za które klienci zapłacą",
        agencies_screen_4_title: "Skaluj na wszystkich klientach",
        subtitle: "Poproś o recenzje na autopilocie. Uzyskaj więcej ocen 5-gwiazdkowych. Zdobądź wyższą pozycję niż konkurencja.",
        title: "Zarządzanie reputacją AI, by",
        title_phrases: {
            google_reviews: "zdobywać więcej opinii w Google",
            autopilot: "prosić o opinie automatycznie",
            suggested_by_chatgpt: "zdobywać sugestie ChatGPT"
        },
        title_agencies: "Zamień opinie w",
        title_agencies_phrases: {
            branded_product: "własny produkt pod Twoją marką",
            recurring_retainers: "miesięczne cykliczne retainer’y",
            revenue_stream: "nowe źródło przychodów",
        },
        title_agencies_feature_summary: "Wszystko, czego potrzebują agencje",
        title_feature_summary: "Wszystko w jednym pakiecie",
        title_mcp: "Zapytaj AI o swoją reputację",
        title_review_flow: "Zamień świetne doświadczenia w opinie",
        subtitle_review_flow: "Proś o opinie automatycznie. Klienci mogą w każdej chwili zostawić publiczną opinię. Prywatny feedback jest opcjonalny.",
        subtitle_mcp: "Połącz Claude, ChatGPT i inne klienty MCP, a potem pytaj o opinie, lokalizacje i outreach językiem naturalnym.",
        subtitle_feature_summary: "Zbieranie, wyświetlanie, AI i integracje — gotowe, gdy Ty jesteś.",
        subtitle_agencies_feature_summary: "Portal white label, dostęp klientów, skala i automatyzacja pod Twoją marką.",
        agencies_screen_1_subtitle: "Daj każdemu klientowi portal, który wygląda jak produkt, który stworzyłeś: Twoje logo, kolory, domena. Potem spakuj zarządzanie opiniami jako usługę cykliczną, do której logują się co miesiąc. Nie polecasz narzędzia. Dostarczasz je.",
        agencies_screen_2_subtitle: "Nie każdy klient powinien dostać wszystko. Zapraszaj zespoły do konkretnych projektów, ustawiaj role i nadpisuj funkcje oraz limity na konto, by pakiety pasowały do Twojego rozliczania. Upselluj dostęp wraz ze wzrostem klientów — bez custom buildów dla każdego pakietu.",
        agencies_screen_3_subtitle: "Nie tylko zarządzaj opiniami. Daj klientom AI, które szkicuje odpowiedzi, taguje feedback i działa przez Claude lub innych asystentów przez serwer MCP projektu. To nowoczesna możliwość, którą agencje mogą pakietować, upsellować i odnawiać — bez zespołu contentowego na każde konto.",
        agencies_screen_4_subtitle: "Jedno miejsce agencyjne. Dziesiątki firm. Prowadź zbieranie opinii, odpowiedzi i raportowanie we wszystkich lokalizacjach klientów z jednego huba, a potem zwiększaj marżę dodając konta. Tak agencje zamieniają reputację w skalowalny strumień przychodów, a nie jednorazowy projekt.",
        title_contact: "Jak możemy pomóc?",
        title_faq: "Często zadawane pytania",
        title_footer: "Przestań gonić za recenzjami. Zacznij je zdobywać.",
        title_ltd: "Zapłać raz i korzystaj wiecznie dzięki naszej ofercie ograniczonej czasowo i dożywotniej.",
        title_pricing: "Każda funkcja. Prosty cennik.",
        title_reviews: "Zobacz, dlaczego jesteśmy nr 1 w zarządzaniu opiniami"
    },
    plans: {
        agency: {
            agency_api: "API agencji",
            branded_portal: "Markowy portal klienta",
            client_invites: "Zaproszenia Klient , role i nadpisania",
            custom_domain: "Niestandardowa domena agencji",
            everything_in_business: "Wszystko w planie biznesowym",
            locations_included: "5 lokalizacji w zestawie",
            review_requests: "5000 próśb o recenzję \/ lokalizacja \/ miesiąc",
            sso: "Logowanie jednokrotne (SSO)",
            support: "Dedykowane wsparcie klienta",
            volume_pricing: "Ceny hurtowe od 49 USD\/mies."
        },
        business: {
            ai: "Odpowiedzi, spostrzeżenia i funkcja „Zapytaj AI” AI",
            api_mcp: "API i Serwer MCP",
            custom_domains: "Niestandardowe domeny e-maili i stron recenzji",
            google_facebook: "Profil firmowy Google i Facebook",
            locations_included: "1 lokalizacja wliczona",
            review_requests: "{count} prośby o recenzję \/ lokalizacja \/ miesiąc",
            support: "Dedykowane wsparcie klienta",
            unlimited_customers: "Nieograniczona liczba klientów",
            volume_pricing: "Ceny hurtowe od 99 USD\/mies."
        },
        selectors: {
            agency_included: "{count} Lokalizacje uwzględnione",
            agency_tier: "+{from}–{to} lokalizacje · {price}\/{month} każda",
            agency_tier_plus: "+{from}+ lokalizacje · {price}\/{month} każda",
            business_tier: "{from}–{to} lokalizacje · {price}\/{month} każda",
            business_tier_plus: "{from}+ lokalizacje · {price}\/{month} każda"
        }
    },
    pricing: {
        faq_business_vs_agency_a: "Business to usługa dla firm zarządzających własną reputacją – z ceną za lokalizację, z rozliczeniem miesięcznym lub rocznym. Agency to usługa dla agencji i konsultantów, którzy potrzebują portalu klienta white-label, własnej domeny agencji, funkcji logowania jednokrotnego (SSO), zaproszeń klienta i nadpisów dla poszczególnych projektów. Abonament Agency jest dostępny tylko miesięcznie i obejmuje 5 lokalizacji na początek.",
        faq_business_vs_agency_q: "Jaka jest różnica między biznesem a agencją?",
        feature_sso_tooltip: "Zezwól zaproszonym klientom na logowanie się do Twojego portalu przy użyciu dostawcy tożsamości swojej firmy za pośrednictwem OpenID Connect (na przykład Auth0, Okta lub Azure AD)."
    },
    mcp_example_prompts: {
        labels: {
            add_customer_and_ask: "Dodaj klienta i poproś o recenzję",
            customers_to_ask: "Znajdź klientów, których chcesz poprosić o recenzje",
            location_leaderboard: "Porównaj wydajność lokalizacji",
            outreach_health: "Audyt jakości dostarczania próśb",
            review_digest: "Tygodniowe podsumowanie recenzji",
            send_review_requests: "Wysyłaj prośby o recenzję zbiorczo"
        },
        texts: {
            add_customer_and_ask: "Dodaj nowego klienta, korzystając z podanych przeze mnie danych kontaktowych, a następnie zaplanuj wysłanie mu prośby o recenzję za pośrednictwem poczty e-mail i wyślij 2 przypomnienia.",
            customers_to_ask: "Wyświetl maksymalnie 50 klientów, którzy nigdy nie zostali poproszeni o recenzję, posortowanych według daty rejestracji (najnowsi na początku). Pomiń osoby, które zrezygnowały z subskrypcji. Uwzględnij imię i nazwisko, adres e-mail i datę rejestracji.",
            location_leaderboard: "Stwórz 90-dniową tabelę wyników według lokalizacji, uwzględniającą liczbę recenzji, średnią ocenę, odsetek 5 gwiazdek i trend w porównaniu z poprzednimi 90 dniami. Sortuj według oceny i zgłaszaj każdy spadek o ponad 0,2 gwiazdki.",
            outreach_health: "W przypadku wiadomości e-mail wysłanych w ciągu ostatnich 14 dni, podaj liczbę wysłanych wiadomości, wskaźnik doręczeń, wskaźnik otwarć, wskaźnik kliknięć i wskaźnik niepowodzeń. Oznacz wszelkie nieprawidłowości.",
            review_digest: "Podsumuj wszystkie recenzje z ostatnich 7 dni. Uwzględnij liczbę, średnią ocenę, podział według źródła i lokalizacji, 3 najważniejsze tematy i 3 najważniejsze zastrzeżenia.",
            send_review_requests: "Dla klientów, którzy zarejestrowali się w ciągu ostatnich 30 dni i nie zostali poproszeni o wystawienie recenzji, zaplanuj prośbę o recenzję e-mailem z 2 przypomnieniami. Najpierw pokaż listę i poczekaj na moje potwierdzenie."
        }
    },
    messages: {
        activated: "Aktywowano pomyślnie.",
        archived: "Archiwizacja zakończona sukcesem.",
        canceled: "Pomyślnie anulowano.",
        cannot_copy: "Nie można skopiować do schowka",
        cname_active: "Status CNAME jest aktywny.",
        cname_not_active: "Status CNAME nie jest jeszcze aktywny.",
        connected: "Połączenie zostało nawiązane.",
        cookie_banner_text: "Używamy plików cookie, aby ulepszyć Twoje wrażenia. Możesz dostosować swoje preferencje lub zaakceptować wszystkie.",
        cookie_category_analytics_desc: "Służy do pomiaru ruchu na stronie internetowej i korzystania z produktów. Te pliki cookie pomagają nam zrozumieć, w jaki sposób odwiedzający korzystają z naszej witryny.",
        cookie_category_essential_desc: "Zawsze aktywne. Te pliki cookie są niezbędne do działania witryny i nie można ich wyłączyć.",
        cookie_category_functional_desc: "Włącz zaawansowane funkcje, takie jak czat na żywo. Te pliki cookie nie śledzą Cię w celach reklamowych.",
        cookie_category_marketing_desc: "Używane do reklam i pomiaru kampanii. Mogą to być piksele reklamowe i narzędzia atrybucji.",
        copied: "Skopiowano pomyślnie.",
        created: "Utworzono pomyślnie.",
        deactivated: "Pomyślnie dezaktywowano.",
        deleted: "Pomyślnie usunięto.",
        disconnected: "Pomyślnie rozłączono.",
        duplicated: "Pomyślnie zduplikowano.",
        error: "Coś poszło nie tak. Spróbuj ponownie.",
        google_connect_failed: "Nie udało się połączyć z Google. Możesz spróbować ponownie lub na razie pominąć ten krok.",
        oauth_consent_intro: "{client} prosi o pozwolenie na dostęp do Twojego konta.",
        oauth_request_missing: "Żądanie autoryzacji OAuth nie istnieje lub wygasło.",
        operation_connection_sync_failed: "Synchronizacja {integration_name} nie powiodła się.",
        operation_connection_sync_progress: "Synchronizacja {integration_name}…",
        operation_connection_sync_success: "Synchronizacja {integration_name} ukończona.",
        operation_customer_import_failed: "Import Klient nie powiódł się.",
        operation_customer_import_progress: "Importowanie klientów…",
        operation_customer_import_success: "Import Klient zakończony.",
        operation_review_import_failed: "Import Recenzja nie powiódł się.",
        operation_review_import_progress: "Importowanie recenzje…",
        operation_review_import_success: "Importowanie Recenzja zakończone.",
        operation_review_scrape_failed: "Import ostatniej recenzji nie powiódł się.",
        operation_review_scrape_progress: "Importowanie ostatnich recenzje…",
        operation_review_scrape_success: "Zakończono importowanie ostatniej recenzji.",
        processed: "Pomyślnie przetworzono.",
        published: "Pomyślnie opublikowano.",
        purchased: "Zakupiono pomyślnie.",
        queued: "Zaplanowano pomyślnie.",
        refreshed: "Pomyślnie odświeżono.",
        removed: "Pomyślnie usunięto.",
        resubscribed: "Pomyślnie ponowna subskrypcja.",
        revoked: "Pomyślnie odwołano.",
        saved: "Pomyślnie zapisano.",
        scheduled: "Zaplanowano pomyślnie.",
        sent: "Pomyślnie wysłano.",
        started: "Rozpoczęto pomyślnie.",
        stopped: "Pomyślnie zatrzymano.",
        sso_failed: "Nie można dokonać autoryzacji za pomocą SSO.",
        sso_invalid_callback: "Nieprawidłowe wywołanie zwrotne SSO.",
        sso_not_configured: "Funkcja SSO nie jest skonfigurowana.",
        sso_openid_config_failed: "Nie można załadować konfiguracji OpenID.",
        sso_token_exchange_failed: "Nie można ukończyć wymiany tokenów SSO.",
        subscribed: "Subskrypcja została pomyślnie zapisana.",
        suspended: "Pomyślnie zawieszono.",
        synced: "Synchronizacja przebiegła pomyślnie.",
        unarchived: "Pomyślnie rozpakowano.",
        unpublished: "Pomyślnie wycofano publikację.",
        unscheduled: "Pomyślnie anulowano harmonogram.",
        unsubscribed: "Pomyślnie anulowano subskrypcję.",
        unsuspended: "Pomyślnie anulowano zawieszenie.",
        updated: "Pomyślnie zaktualizowano.",
        upgraded: "Pomyślnie uaktualniono.",
        validated: "Pomyślnie zatwierdzono.",
        verified: "Pomyślnie zweryfikowano."
    },
    notices: {
        agency: "Prowadzisz agencję? Możesz oznaczyć nasz produkt białą etykietą, aby Twoi klienci widzieli Twoją markę tylko podczas korzystania z usługi.",
        connected_apps: "Tutaj pojawią się aplikacje, z którymi łączysz się przez MCP.",
        connector: "Importuj klientów z tysięcy aplikacji dzięki {brand}.",
        customer_messages: "Poproś o recenzję, aby zaplanować wiadomości.",
        customer_reviews: "Poproś tego klienta o recenzję.",
        customers: "Zaimportuj swoich klientów i zacznij prosić ich o wystawienie recenzji.",
        external_links: "Dodaj linki zewnętrzne do swojego portalu klienta, aby pomóc sprzedawać swoje usługi. Te linki będą wyświetlane klientom na pasku bocznym.",
        links: "Dodaj przyciski do swojej strony, aby zostawić recenzję na stronach internetowych osób trzecich.",
        locations: "Utwórz lokalizację, aby móc przypisywać recenzje do wielu lokalizacji.",
        ltd: "Odblokuj dożywotni dostęp za pomocą swojego kodu dostępu. Każdy kod zawiera ograniczoną liczbę miesięcznych żądań, plus wszystkie funkcje. Kody można łączyć. 3 kody usuwają cały nasz branding i odblokowują funkcje agencji. Wprowadź swój kod dostępu poniżej.",
        mcp_example_prompts: "Po połączeniu z serwer MCP wklej powyższe informacje do asystenta jako punkt wyjścia.",
        messages: "Wszystkie prośby i przypomnienia będą się tutaj pojawiać, gdy klienci poproszą o wystawienie recenzji.",
        no_commissions: "Nie zarobiłeś jeszcze żadnej prowizji.",
        no_payouts: "Wypłaty są wysyłane ręcznie, gdy zatwierdzone saldo osiągnie co najmniej 50,00 USD i Twoje konto bankowe zostanie połączone.",
        no_projects: "Nie przypisano Ci jeszcze projektu. Skontaktuj się z administratorem, aby uzyskać dostęp.",
        no_referrals: "Nikogo jeszcze nie poleciłeś. Udostępnij swój link polecający, aby zacząć.",
        qr_codes: "Twórz kody QR z niestandardowymi kolorami, lokalizacjami i etykiety. Pobierz w formacie SVG lub PNG.",
        referrals_share_subject: "Mój menedżer reputacji AI",
        referrals_share_text: "Moja tajna broń w zdobywaniu recenzji biznesowych: More Good Reviews. Zarządzanie reputacją za pomocą sztucznej inteligencji, które naprawdę działa. Zarejestruj się za pomocą mojego linku:",
        review_pages: "Twój projekt może mieć wiele stron recenzji, na których Twoi klienci mogą zostawiać recenzje. Jest to przydatne dla firm z więcej niż jedną lokalizacją.",
        reviews: "Czekamy na recenzje Twoich klientów.",
        showcase: "Dopiero zaczynamy.",
        signatures: "Utwórz podpis e-mail, który możesz skopiować i wkleić do aplikacji pocztowej.",
        sources: "Utwórz źródło, aby móc kategoryzować swoje recenzje.",
        tag_rules: "Utwórz regułę, aby automatycznie kategoryzować recenzje za pomocą sztucznej inteligencji.",
        tags: "Utwórz etykietę, aby kategoryzować swoje recenzje i klientów.",
        unauthorized: "Nie masz uprawnień dostępu do tej strony.",
        unsubscribed: "Zostałeś wypisany z próśb o recenzję.",
        webhooks: "Dodaj webhooki, aby otrzymywać powiadomienia o zdarzeniach na platformie.",
        widgets: "Utwórz widżety, aby osadzać recenzje na swojej stronie internetowej.",
        your_referral_link_text: "Udostępnij swój link, aby zarabiać cykliczną prowizję w wysokości {rate}% od każdej płatności od poleconych klientów. Wypłaty są wysyłane ręcznie, gdy zatwierdzone saldo osiągnie co najmniej 50,00 USD."
    },
    notification_types: {
        descriptions: {
            imports: "Wysyłane po zakończeniu importu",
            new_reviews: "Wysyłane po otrzymaniu recenzji",
            sent_replies: "Wysyłane, gdy na recenzje zostanie udzielona automatyczna odpowiedź",
            weekly_reports: "Podsumowanie aktywności wysyłane co tydzień"
        },
        names: {
            imports: "Import",
            new_reviews: "Nowe Recenzje",
            sent_replies: "Wysłane odpowiedzi",
            weekly_reports: "Raporty tygodniowe"
        }
    },
    roles: {
        manager: "Menedżer",
        operator: "Operator",
        owner: "Właściciel",
        super_admin: "Administrator",
        viewer: "Dozorca"
    },
    tasks: {
        automate: "Turn on automatic review requests and reminders. Each customer is contacted once, and can unsubscribe anytime.",
        customers: "Import customers with names and email or phone — manually, via Stripe, HubSpot, app connectors, the API, or by BCC’ing your project email on invoices.",
        google: "Connect Google Business Profile to import reviews, keep them in sync, and reply from here.",
        review_page: "Customize the page that captures reviews and can send customers to third-party sites — text, layout, fields, links, and redirects.",
        strategy: "Choose when customers are asked for reviews. We’ve set a simple default you can change anytime.",
        templates: "Edit the request and reminder emails customers receive. Both include one-click ratings, plus your logo and branding."
    },
    titles: {
        accept_invite: "Akceptuj zaproszenie",
        accepting_invite: "Akceptowanie zaproszenia",
        access_denied: "Odmowa dostępu",
        account: "Konto",
        actions: "Akcje",
        add_custom_field: "Dodaj pole niestandardowe",
        add_ons: "Dodatki",
        address: "Adres",
        agencies: "Agencje",
        agency: "Agencja",
        ai_assistant: "Asystent AI",
        ai_highlights: "Najważniejsze informacje o sztucznej inteligencji",
        ai_replies: "Odpowiedzi AI",
        ai_review_suggestions: "Sugestie recenzji AI",
        analytics: "Analityka",
        api: "API",
        api_key: "Klucz API",
        appearance: "Wygląd",
        application_connectors: "Złącza aplikacji",
        attributes: "Atrybuty",
        authorize: "Autoryzować",
        auto_tagging: "Automatyczne tagowanie",
        automatic_review_collection: "Automatyczne zbieranie recenzji",
        billing: "Rozliczanie",
        branding: "Branding",
        change_password: "Zmień hasło",
        clients: "Klienci",
        cname: "CNAME",
        conditions: "Warunki",
        connected_apps: "Połączone aplikacje",
        contact_us: "Skontaktuj się z nami",
        cookie_policy: "Polityka plików cookie",
        cookie_preferences: "Preferencje dotyczące plików cookie",
        copy: "Kopia",
        create_your_account: "Utwórz swoje konto",
        crms: "CRMs",
        css: "CSS",
        custom_field: "Pole niestandardowe",
        custom_fields: "Pola niestandardowe",
        custom_icons: "Niestandardowe ikony",
        customer: "Klient",
        customer_facing_pages: "Strony przeznaczone dla klientów",
        customers: "Klienci",
        dashboard: "Panel sterowania",
        details: "Bliższe dane",
        dmarc: "DMARC",
        domain: "Domena",
        dpa: "Umowa o przetwarzaniu danych",
        dsar: "Żądanie o dostęp do danych podmiotu danych",
        email_address: "Adres e-mail",
        email_messages: "Wiadomości e-mail",
        email_settings: "Ustawienia poczty e-mail",
        email_usage: "Użycie poczty e-mail",
        emails: "E-maile",
        embed_code: "Osadź kod",
        examples: "Przykłady",
        export: "Eksport",
        external_link: "Link zewnętrzny",
        external_link_num: "Link zewnętrzny #{num}",
        external_links: "Linki zewnętrzne",
        field: "Pole",
        fields: "Pola",
        filters: "Filtry",
        form_fields: "Pola formularza",
        got_access_code: "Masz kod dostępu?",
        how_it_works: "Jak to działa",
        incentive: "Zachęta",
        instructions: "Instrukcje",
        integration: "Integracja",
        integrations: "Integracje",
        javascript: "JavaScript",
        latest_reviews: "Najnowsze Recenzje",
        lifetime_deal: "Oferta na całe życie",
        limits: "Ograniczenia",
        link: "Link",
        links: "Linki",
        location: "Lokalizacja",
        location_picker: "Wybór lokalizacji",
        locations: "Lokalizacje",
        log_in: "Zaloguj się",
        log_out: "Wyloguj się",
        make_default: "Ustaw jako domyślne",
        manage_limits: "Zarządzaj limitami",
        manage_overrides: "Zarządzaj nadpisaniami",
        manage_review: "Zarządzaj recenzją",
        mcp_example_prompts: "Przykładowe monity",
        mcp_server: "Serwer MCP",
        message: "Wiadomość",
        messages: "Wiadomości",
        meta: "Meta",
        no_clients: "Brak klientów",
        no_commissions: "Brak prowizji",
        no_connected_apps: "Brak połączonych aplikacji",
        no_custom_fields: "Brak pól niestandardowych",
        no_customers: "Brak klientów",
        no_links: "Brak Linki",
        no_locations: "Brak lokalizacji",
        no_members: "Brak członków",
        no_messages: "Brak wiadomości",
        no_payouts: "Brak wypłat",
        no_projects: "Brak projektów",
        no_qr_codes: "Brak kodów QR",
        no_referrals: "Brak poleceń",
        no_review_pages: "Brak Strony Recenzji",
        no_reviews: "Brak recenzji",
        no_tags: "Brak Etykiety",
        no_team_members: "Brak członków zespołu",
        no_template: "Brak szablonu",
        no_widgets: "Brak widżetów",
        notifications: "Powiadomienia",
        options: "Opcje",
        overview: "Przegląd",
        payment_method: "Metoda płatności",
        photo: "Zdjęcie",
        plans: "Plany",
        powered_by: "Zasilane przez",
        pricing: "Wycena",
        privacy_policy: "Polityka prywatności",
        profile: "Profil",
        project: "Projekt",
        project_limits: "Ograniczenia projektu",
        project_overrides: "Nadpisania projektu",
        projects: "Projekty",
        qr_code: "Kod QR",
        qr_codes: "Kody QR",
        ratings: "Oceny",
        redeem_access_code: "Zrealizuj kod dostępu",
        redirecting: "Przekierowywanie",
        redirects: "Przekierowania",
        referrals_commissions: "Prowizje",
        referrals_payouts: "Wypłaty",
        referral_program: "Warunki programu poleceń",
        reminders: "Przypomnienia",
        reply: "Odpowiedź",
        request: "Żądanie",
        request_options: "Opcje żądania",
        requests: "Prośby",
        required: "Wymagany",
        reschedule_message: "Zmień harmonogram wiadomości",
        reset_password: "Zresetuj hasło",
        retries: "Ponowne próby",
        review: "Recenzja",
        review_link: "Link do recenzji",
        review_page: "Strona recenzji",
        review_pages: "Strony recenzji",
        review_spotlight: "Wyróżniona recenzja",
        review_suggestions: "Sugestie recenzji",
        review_wall: "Ściana recenzji",
        reviewer: "Autor recenzji",
        reviews: "Recenzje",
        save_changes: "Zapisz zmiany",
        schedule: "Harmonogram",
        scrape_a_website: "Pobierz ze strony",
        search_engines: "Wyszukiwarki",
        sections: "Sekcje",
        select_csv_file: "Wybierz plik CSV",
        select_project: "Wybierz projekt",
        selecting_project: "Wybieranie projektu",
        sending_domain: "Wysyłanie domeny",
        sending_limits: "Limity wysyłania",
        settings: "Ustawienia",
        setup: "Organizować coś",
        setup_basics: "Twoja strategia Prośba",
        setup_business: "Zacznijmy",
        setup_google: "Twój profil firmowy w Google",
        setup_trusted: "Zaufało nam ponad 5000 firm",
        showcase: "Showcase",
        sign_up: "Zapisać się",
        signature: "Podpis",
        signatures: "Podpisy",
        signing_in: "Logowanie",
        single_sign_on: "Pojedyncze logowanie",
        slug: "Slug",
        sms: "SMS",
        sms_messages: "Wiadomości SMS",
        sms_usage: "Użycie SMS",
        smtp_configuration: "Konfiguracja SMTP",
        source: "Źródło",
        sources: "Źródła",
        space: "Przestrzeń robocza",
        spaces: "Przestrzenie robocze",
        stats: "Statystyki",
        sub_processors: "Podprocesorzy",
        success_page: "Strona sukcesu",
        summary: "Streszczenie",
        tag: "Etykieta",
        tag_rule: "Reguła tagu",
        tags: "Etykiety",
        team_members: "Członkowie zespołu",
        template: "Szablon",
        templates: "Szablony",
        terms_of_service: "Warunki korzystania z usługi",
        two_factor_authentication: "Uwierzytelnianie dwuskładnikowe",
        unable_to_complete_request: "Nie można zrealizować żądania",
        unique_review_link: "Unikalny link do recenzji",
        unsent_messages: "Niewysłane wiadomości",
        unsubscribe: "Wypisz się",
        update_plan: "Aktualizuj plan",
        usage: "Stosowanie",
        user: "Użytkownik",
        user_info: "Informacje o użytkowniku",
        verify_email_address: "Zweryfikuj adres e-mail",
        verifying_email: "Weryfikacja adresu e-mail",
        visibility: "Widoczność",
        webhook: "Webhook",
        webhooks: "Webhooki",
        website: "Strona internetowa",
        white_label_api: "API białej etykiety",
        white_label_client_portal: "Portal Klienta White Label",
        white_label_image_urls: "Adresy URL obrazów White Label",
        white_label_sending_domain: "Biała etykieta wysyłająca domenę",
        white_label_widget_tag: "Tag widżetu białej etykiety",
        widget: "Widżet",
        widget_num: "Widżet #{num}",
        widgets: "Widżety",
        your_plan: "Twój plan"
    },
    tones: {
        apologetic: "Przepraszający",
        casual: "Zwykły",
        empathetic: "Empatyczny",
        enthusiastic: "Entuzjastyczny",
        formal: "Formalny",
        friendly: "Przyjazny",
        grateful: "Wdzięczny",
        humorous: "Humorystyczny",
        informative: "Informacyjny"
    },
    widgets: {
        labels: {
            alignment: "Wyrównanie",
            animation: "Ożywienie",
            autoplay: "Automatyczne odtwarzanie",
            autoplay_delay: "Opóźnienie automatycznego odtwarzania",
            avatar: "Awatara",
            background_color: "Kolor tła",
            border: "Granica",
            border_color: "Kolor obramowania",
            border_radius: "Promień graniczny",
            border_width: "Szerokość obramowania",
            carousel: "Karuzela",
            colors: "Zabarwienie",
            company: "Firma",
            customer: "Klient",
            customer_position: "Pozycja Klienta",
            date: "Data",
            delay: "Opóźnienie",
            drop_shadow: "Cień rzucony",
            duration: "Czas trwania",
            filters: "Filtry",
            font: "Czcionka",
            font_emphasis: "Podkreślenie czcionki",
            font_family: "Rodzina czcionek",
            font_size: "Rozmiar czcionki",
            include_hidden: "Uwzględnij ukryte Recenzje",
            layout: "Układ",
            limit: "Recenzje na stronę",
            location_ids: "Lokalizacje",
            marquee: "Marquee",
            max_slides: "Maksymalna liczba slajdów",
            max_width: "Maksymalna szerokość",
            name_convention: "Nazwa",
            padding: "Wewnętrzny odstęp",
            pagination: "Paginacja",
            quotes: "Cytaty",
            rating: "Ocena",
            rating_round: "Zaokrąglanie",
            rating_round_hundredth: "Najbliższa setna (4,94)",
            rating_round_tenth: "Najbliższa dziesiąta część (4,9)",
            review: "Recenzja",
            review_chars: "Długość recenzji",
            review_count: "Liczba recenzji",
            review_id: "Recenzja",
            review_ids: "Recenzje",
            review_ids_for_faces: "Recenzje dla Faces",
            reviews: "Recenzje",
            schema: "Schemat",
            schema_name: "Nazwa firmy",
            schema_type: "Rodzaj działalności",
            score: "Najniższa ocena",
            show_on_mobile: "Pokaż na urządzeniu mobilnym",
            slider: "Suwak",
            source: "Źródło",
            source_ids: "Źródła",
            source_position: "Pozycja źródłowa",
            speed: "Prędkość",
            star_color: "Kolor gwiazdy",
            star_display: "Wyświetlacz gwiazdowy",
            star_size: "Rozmiar gwiazdy",
            star_spacing: "Star Spacing",
            star_style: "Star Style",
            star_style_classic: "Classic",
            star_style_sharp: "Sharp",
            tag_ids: "Etykiety",
            take: "Maksymalna liczba recenzji",
            text_color: "Kolor tekstu",
            truncate: "Skróć recenzję",
            visible_slides: "Widoczne slajdy",
            width: "Szerokość"
        },
        types: {
            badge: "Odznaka",
            carousel: "Karuzela",
            carousel_dynamic: "Dynamiczna karuzela",
            corner: "Narożnik",
            corner_dynamic: "Dynamiczny Kącik",
            faces: "Twarze",
            headline: "Nagłówek",
            highlights: "Przegląd najważniejszych wydarzeń",
            marquee: "Marquee",
            spotlight: "Wyróżnienie",
            wall: "Ściana"
        }
    }
}